var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManualDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 450,
    height: 210
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "manual_desktop_svg__a",
    x1: 0.825,
    y1: 0.5,
    x2: -0.02,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#158462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68c181"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7208"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1892",
    fill: "url(#manual_desktop_svg__a)",
    d: "M0 0h450v210H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7255"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4007",
    d: "M395.218 34.358l5.152 175.641h49.628v-210H309.647l85.572 34.357z",
    fill: "#158462"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4008",
    d: "M395.218 34.358L400.37 210l-5.152-175.641z",
    fill: "#00ad9e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4009",
    d: "M312.829 70.886l4.081 139.115h83.461l-5.152-175.642L309.647.002H136.284l176.545 70.884z",
    fill: "#17936f"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4010",
    d: "M230.439 107.411L233.449 210h83.461l-4.081-139.114L136.284.002H0v14.884l230.439 92.522z",
    fill: "#209e6e"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4011",
    d: "M148.05 143.936L149.988 210h83.461l-3.01-102.589L0 14.886v69.606l66.189 26.575z",
    fill: "#3faf77"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4012",
    d: "M66.528 210h83.46l-1.938-66.064-81.86-32.867L.001 84.494V154.1l65.661 26.363z",
    fill: "#68c181"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4013",
    d: "M65.661 180.463L0 154.1V210h66.527z",
    fill: "#7cce87"
  })))));
}

export default __webpack_public_path__ + "static/media/manual_desktop.92f6553eda2535580da4ba3f43271c17.svg";
export { SvgManualDesktop as ReactComponent };